/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Collapse, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/Logos/logo_color.svg'
import logo_solo from '../../Recursos/Logos/logo_solo_blanco.svg'
import {Menu, ShoppingCart} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useNavigate} from "react-router";
import {useState} from "react";


const BarraPc = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <img
                                onClick={() => navigate('/Home')}
                                src={logo} width={110} height={'auto'} style={{cursor: 'pointer'}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center'}}>
                            <TextField
                                fullWidth
                                label={'Bucar Producto'}
                                variant={'outlined'}
                                size={'small'}
                                slotProps={{
                                    input: {
                                        endAdornment: (
                                            <InputAdornment position="start" sx={{mr: -1.5}}>
                                                <Button sx={{width: 150, borderRadius: 1, pt: 0.6, pb: 0.4}}>
                                                    Buscar
                                                </Button>
                                            </InputAdornment>
                                        )
                                    }
                                }}
                            />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <Button startIcon={<ShoppingCart/>} variant={'outlined'} sx={{width: 150}}>
                                Carrito
                            </Button>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    px: 3,
                    py: 0
                }}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3, py: 0.1}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 9}}
                            spacing={4}
                        >


                            <Typography
                                variant={'text'}
                                onMouseEnter={() => setOpen(true)}
                                onMouseLeave={() => setOpen(false)}
                                sx={{
                                    color: '#fff',
                                    backgroundColor: '#000',
                                    borderRadius: 0,
                                    px: 4,
                                    pt: 1,
                                    pb: 1.7,
                                    cursor: 'pointer'
                                }}
                            >
                                <Menu sx={{mt: 0.7, mb: -0.7, pr: 1}}/>
                                CATEGORIAS

                                <Collapse in={open} timeout="auto" unmountOnExit sx={{position: 'absolute', mt: 1}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        sx={{
                                            backgroundColor: '#fff',
                                            py: 2,
                                            maxWidth: 250,
                                            borderRadius: 0,
                                            boxShadow: 4,
                                            px: 2
                                        }}
                                        spacing={2}
                                    >


                                        {CATEGORIAS.map((it) => {
                                            return (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start', pl: 2}}>
                                                    <Typography sx={{
                                                        color: '#00000090',
                                                        fontSize: 14,
                                                        fontWeight: 600
                                                    }}>{it}</Typography>
                                                </Grid>

                                            )
                                        })}


                                    </Grid>
                                </Collapse>

                            </Typography>

                            {CATEGORIAS.map((item, index) => {
                                return (
                                    <Typography sx={{
                                        fontSize: 14,
                                        color: '#fff',
                                        fontWeight: 500,
                                        borderBottom: 1,
                                        borderColor: '#ffffff00',
                                        transition: 'all 0.2s ease-in-out',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            borderColor: '#fff'
                                        }
                                    }}>
                                        {item}
                                    </Typography>
                                )
                            })}


                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <Button
                                variant={'text'}
                                sx={{color: '#fff', borderRadius: 0, fontSize: 12, fontWeight: 600, lineHeight: 1.2}}
                                startIcon={<img src={logo_solo} style={{width: 40, height: 'auto'}}/>}
                            >COTIZA TU FORMULA</Button>
                        </Grid>
                    </Grid>

                </Grid>


            </Grid>

        </Grid>


    )

}
export default BarraPc

const CATEGORIAS = ['LENTES DE CONTACTO', 'GAFAS PARA HOMBRE', 'GAFAS PARA MUJER', 'GAFAS PARA NIÑO']